import angular from 'angular';
import TopMenuComponent from './top-menu-component';

export default angular
  .module('top-menu', [])
  .component('topMenu', new TopMenuComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/top-menu/top-menu-module.js